import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '@core/services';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private _pendingRequests = 0;

  get pendingRequests(): number {
    return this._pendingRequests;
  }

  constructor(private loaderService: LoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isSilent = request.headers.get('silent-loader');

    if (isSilent) {
      if (isSilent === 'true') {
        return next.handle(request.clone({ headers: request.headers.delete('silent-loader') }));
      }

      request = request.clone({ headers: request.headers.delete('silent-loader') });
    }

    this.loaderService.show();
    this._pendingRequests++;

    return next.handle(request).pipe(
      finalize(() => {
        this._pendingRequests--;

        if (0 === this._pendingRequests) {
          this.loaderService.hide();
        }
      })
    );
  }
}
